import { Components, Theme } from "@mui/material/styles";

export default {
  MuiToggleButtonGroup: {
    defaultProps: {
      size: "small",
      color: "primary",
    },
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        "&.MuiToggleButtonGroup-root": {
          "& button": {
            minWidth: 100,
          },
          "& button:first-of-type": {
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
          },
          "& button:last-child": {
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
          },
        },
        "& button.Mui-selected": {
          fontWeight: "bold",
          border: `1px solid ${theme.palette.primary.main} !important`,
        },
      }),
    },
  } as Components["MuiToggleButton"],
};
